import { SelectIcon as GSBSelectIcon } from '@gluestack-ui/themed';

import Icon from 'react-native-vector-icons/FontAwesome6';

import { ISelectIcon } from './types';

export const SelectIcon = ({ name, ...rest }: ISelectIcon) => {
  return (
    <GSBSelectIcon
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      as={(props: any) => <Icon name={name} {...props} />}
      {...rest}
    />
  );
};
